import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { StudentRegistration } from "../../models/student-registration";
import { Observable } from "rxjs";
import { environment } from 'src/environments/environment';
import { AccessMailResult } from '../students/students.service';
import moment from 'moment';

@Injectable({
  providedIn: 'root'
})
export class RegistrationsService {
  private readonly serviceName = 'registrations';
  private readonly publicHeaders = { headers: new HttpHeaders({ "Authorization": environment.apiKeyPublic })};
  private readonly internalHeaders = { headers: new HttpHeaders({ "Authorization": environment.apiKeyInternal })};

  constructor(private http: HttpClient) { }

  public get(): Observable<StudentRegistration[]> {
    return this.http.get<StudentRegistration[]>(
      `${environment.apiUrl}${this.serviceName}/get.php`, this.internalHeaders
    );
  }

  public set(registration: StudentRegistration): Observable<void> {
    const payload = `firstname=${encodeURIComponent(registration.firstName)}&` +
                    `lastname=${encodeURIComponent(registration.lastName)}&` +
                    `birthday=${encodeURIComponent(moment(registration.birthday).format('YYYY-MM-DD'))}&` +
                    `gender=${encodeURIComponent(registration.gender)}&` +
                    `street=${encodeURIComponent(registration.street)}&` +
                    `house=${encodeURIComponent(registration.house)}&` +
                    `zip=${encodeURIComponent(registration.zip)}&` +
                    `city=${encodeURIComponent(registration.city)}&` +
                    `phone=${encodeURIComponent(registration.phone)}&` +
                    `email=${encodeURIComponent(registration.email)}&` +
                    `accountHolder=${encodeURIComponent(registration.accountHolder)}&` +
                    `iban=${encodeURIComponent(registration.iban)}&` +
                    `bic=${encodeURIComponent(registration.bic)}&` +
                    `bank=${encodeURIComponent(registration.bank)}&` +
                    `contractType=${encodeURIComponent(registration.contractType)}&` +
                    `applicationConsent=${encodeURIComponent(registration.applicationConsent)}&` +
                    `dataChangeConsent=${encodeURIComponent(registration.dataChangeConsent)}&` +
                    `privacyPolicyConsent=${encodeURIComponent(registration.privacyPolicyConsent)}&` +
                    `directDebitConsent=${encodeURIComponent(registration.directDebitConsent)}&` +
                    `returnDebitConsent=${encodeURIComponent(registration.returnDebitConsent)}&` +
                    `dataStorageConsent=${encodeURIComponent(registration.dataStorageConsent)}&` +
                    `multimediaConsent=${encodeURIComponent(registration.multimediaConsent)}`

    return this.http.post<void>(
      `${environment.apiUrl}${this.serviceName}/set.php`,
      payload,
      this.publicHeaders
  );
}

  public del(registration: StudentRegistration): Observable<void> {
    const payload = `rid=${registration.rid}`;

    return this.http.post<void>(
      `${environment.apiUrl}${this.serviceName}/del.php`,
      payload,
      this.internalHeaders
    );
  }
  
  public import(registration: StudentRegistration): Observable<{ result: boolean; accessMail: AccessMailResult }> {
    const payload = `rid=${registration.rid}`;

    return this.http.post<{ result: boolean; accessMail: AccessMailResult }>(
      `${environment.apiUrl}${this.serviceName}/import.php`,
      payload,
      this.internalHeaders
    );
  }
}
